<template>
  <div
    class="modal fade"
    id="rewritePolicyModal"
    @keyup.esc.prevent="closeModal"
    tabindex="-1"
    aria-labelledby="rewritePolicyModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header p-5 justify-content-between">
          <h5 class="modal-title" id="rewritePolicyModalLabel">
            {{ policy.number ?? policy.global }}
          </h5>
          <button @click="closeModal" type="button" class="btn-close ms-10"></button>
        </div>
        <div class="modal-body p-5">
          <div v-if="loading" class="d-flex align-items-center justify-content-center py-10">
            <div class="d-flex flex-column align-items-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span class="text-gray-600 fs-7 mt-3">Загрузка данных договора...</span>
            </div>
          </div>
          <section class="policy-info__detail">
            <div v-if="!loading" class="podft-list p-4">
              <policy-info :policy="policy" />
              <policy-linked v-if="linked && linked.length" :linked="linked" />
              <div class="mb-5">
            <div class="row">
              <div class="col-lg-6">
                <policy-insurer :insurer="policy.insurer" />
                <policy-object v-if="policy.vehicle && policy.vehicle.length" :vehicles="policy.vehicle" />
              </div>
              <div class="col-lg-6">
                <policy-insured v-if="policy.insureds && policy.insureds.length" :insureds="policy.insureds" />
              </div>
            </div>
            </div>
            </div>
          </section>
        </div>
        <div class="modal-footer p-2 justify-content-between">
          <button type="button" class="btn btn-sm btn-secondary" @click="closeModal">Закрыть</button>
          <button type="button" class="btn btn-sm btn-primary" :disabled="loading" @click="rewritePolicy">Переоформить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PolicyInfo from '@/components/Modals/Policy/ModalItems/PolicyInfo.vue';
import PolicyInsurer from '@/components/Modals/Policy/ModalItems/PolicyInsurer.vue';
import PolicyObject from '@/components/Modals/Policy/ModalItems/PolicyObject.vue';
import PolicyInsured from '@/components/Modals/Policy/ModalItems/PolicyInsured.vue';
import PolicyLinked from '@/components/Modals/Policy/ModalItems/PolicyLinked.vue';
  export default {
  name: 'RewritePolicyModal',
  components: {
    PolicyInfo,
    PolicyInsurer,
    PolicyObject,
    PolicyInsured,
    PolicyLinked
  },
  emits: ['createRewritePolicy'],
  props: {
    policy: {
      type: Object,
      required: true
    },
    policyType: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    linked: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById('rewritePolicyModal')?.addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal')) {
          this.closeModal()
        }
      })
    }, 10)
  },
  methods: {
    closeModal() {
      window.bootstrap.Modal.getInstance(document.getElementById('rewritePolicyModal'))?.hide()
      this.$store.commit('setRewritePolicyModalShow', false)
    },
    rewritePolicy() {
      this.$emit('createRewritePolicy', this.policy.global, this.policy.ulid)
    }
  }
}
</script>

<style scoped>
</style>